import React, { useState, useEffect, useContext } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Button, Container } from "reactstrap";
import swal from 'sweetalert';
import { AppContext } from "../../../context/app-context";
import AssessmentHeader from "../../Diet/component/AssessmentHeader";
import { riskAssessmentQuestions, riskAssessmentQuestionOption } from "../../../context/staticData";
import RadioButton from "../../Diet/component/RadioButton";
import UserDetails from "./UserDetails";
import HeightWidth from "./HeightWidth";
import { useRiskAssessment } from "../../../hooks/useRiskAssessment";
import { sendFirebaseEvent } from "../../../helper/mobile";

const Questions = () => {

	const [state, dispatch] = useContext(AppContext);
	const { saveRiskAssessment } = useRiskAssessment();
  	let navigate = useNavigate();
  	const { questionType } = useParams();

	const [selectedOption, setSelectedOption] = useState();
	const [question, setQuestion] = useState();

	useEffect(() => {

		if(Object.keys(state.user).length === 0) {
			const token = localStorage.getItem('token');
			navigate('/riskAssessment?'+token);
		}

		if(state.user?.gender.toLowerCase() === 'female') {
			let checkGest = riskAssessmentQuestions.find(obj => obj.name === 'gestationalDiabetes');
			if(!checkGest) {
				const newEle = {
					name: 'gestationalDiabetes',
					btnText: 'Next',
					title: 'Have you ever been diagnosed with gestational diabetes?',
					footerText: 'Men are more likely than women to have undiagnosed diabetes'
				};
				riskAssessmentQuestions.splice( 1, 0,  newEle);
			}
		}

	}, []);

	useEffect(() => {
		if(questionType) {
			const assessment = riskAssessmentQuestions.find(obj => obj.name === questionType);
			setQuestion(assessment);
			if(assessment.name === "diabetes")
				setSelectedOption(state.riskAssessment.diabetes);
			else if(assessment.name === "bloodPressure")
				setSelectedOption(state.riskAssessment.bloodPressure)
			else if(assessment.name === "physicallyActive")
				setSelectedOption(state.riskAssessment.physicallyActive)
			else if(assessment.name === "gestationalDiabetes")
				setSelectedOption(state.riskAssessment.gestationalDiabetes)
			else if(assessment.name === "bmi")
				setSelectedOption(state.riskAssessment.bmi)
		}
	},[questionType]);

	const handleOnChange = (event) => {
		setSelectedOption(event.target.value);
		let payloadLet;
		if(question.name === 'diabetes')
			payloadLet = { diabetes:event.target.value };
		else if(question.name === 'bloodPressure')
			payloadLet = { bloodPressure:event.target.value };
		else if(question.name === 'physicallyActive')
			payloadLet = { physicallyActive:event.target.value };
		else if(question.name === 'gestationalDiabetes')
			payloadLet = { gestationalDiabetes:event.target.value };
		dispatch({
			type: "RISK_ASSESSMENT",
			payload: payloadLet
		});
	}
  

	const onClickButton = (url) => {
		
		if(url === 'userDetails')
			sendFirebaseEvent('ra_begin_assessment_btn_click', 'click_event')
		
		if(url === 'currentHeightWeight') {
			const tempBmi = JSON.parse(localStorage.getItem('tempBmi'));
			if(tempBmi.weight === "" || tempBmi.height === "" || parseInt(tempBmi.bmi) < 16) {
				swal({
					className: "swal-height-width-change",
					title: "Hmm that seems odd..",
					text: "the entered height - weight combination seems incorrect, please verify",
					buttons: "Okay"
				})
				return false;
			}
			
			const userData = state.user;
			if(tempBmi.height !== userData.height || tempBmi.heightUnit !== userData.heightUnit || tempBmi.weight !== userData.weight || tempBmi.weightUnit !== userData.weightUnit){
				swal({
					className: "swal-height-width-change",
					title: "Are you sure?",
					text: "Changes you make here will be updated to your profile.",
					buttons: ["Cancel", "Yes, I’m sure"]
				}).then((willDelete) => {
					if (willDelete) {
						dispatch({
							type: "USER_DETAILS",
							payload: { 
								height: tempBmi.height,
								heightUnit: tempBmi.heightUnit,
								weight: tempBmi.weight,
								weightUnit: tempBmi.weightUnit
							 }
						});
						dispatch({
							type: "RISK_ASSESSMENT",
							payload: { bmi:tempBmi }
						});
						document.body.classList.add('loading-indicator');
						setTimeout(function(){
							saveRiskAssessment()
						}, 500);
						sendFirebaseEvent('ra_submit_btn_click', 'click_event', 'yes')
					}else {
						sendFirebaseEvent('ra_submit_btn_click', 'click_event', 'cancel')
					}
				});
			}else {
				document.body.classList.add('loading-indicator');
				setTimeout(function(){
					saveRiskAssessment()
				}, 500);
				sendFirebaseEvent('ra_submit_btn_click', 'click_event')
			}
			
		}else {
			const index = riskAssessmentQuestions.findIndex(obj => obj.name === url);
			navigate(`/riskAssessment/question/${riskAssessmentQuestions[index+1].name}`);
		}
	}

  const GetQuestionPage = ({curQuestion}) => {
    if(curQuestion.name === 'userDetails')
      return <UserDetails user={state?.user} />
    else if(curQuestion.name === 'currentHeightWeight')
      return <HeightWidth user={state?.user} />
    else
      return <RadioButton radioList={riskAssessmentQuestionOption} selectedPlanType={selectedOption} onClickRadio={handleOnChange} />
  }

  const findIndex = riskAssessmentQuestions.findIndex(obj => obj.name === questionType);
  const percentage = (100 * (findIndex+1)) / (riskAssessmentQuestions.length);
  return(
    <>
      <AssessmentHeader progressPer={percentage} total={riskAssessmentQuestions.length} currentPage={findIndex+1} isRisk={state?.riskAssessment?.preRiskAssessment} />
      <Container>
        <h2 className='assessment-page-title mb-2 text-center'>{question?.title}</h2>
        <div className={question?.name !== 'userDetails' ? 'd-flex flex-column min-vh-55 justify-content-center align-items-center' : 'justify-content-center align-items-center'}>
          { question && <GetQuestionPage curQuestion={question} /> }
        </div>
      </Container>
      <div className="fix-div-button-question">
        <div className="ps-3 pe-3"><Button className="risk-btn mb-4" onClick={() => onClickButton(question?.name)} disabled={selectedOption || question?.name === 'userDetails' ? false : true}>{question?.btnText}</Button></div>
        {question?.footerText &&
          <div className="risk-question-footer">
            <p className="mb-0 text-center">{question.footerText}</p>
          </div>
        }
      </div>
    </>
  )
};

export default Questions